"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { cloneElement } from 'react';
import { TunnelEntry } from '@mittwald/react-tunnel';
import { SlotContextProvider } from '../slotContext/SlotContextProvider.mjs';
import { useProps } from '../hooks/useProps.mjs';
import { mergeRefs } from '@react-aria/utils';

function flowComponent(componentName, ImplementationComponentType) {
  function Component(propsFromArgument) {
    const { ref: refFromProps = null, ...props } = propsFromArgument;
    const {
      ref: refFromContext = null,
      tunnelId,
      wrapWith,
      ...propsWithContext
    } = useProps(
      componentName,
      props
    );
    const implementationTypeProps = propsWithContext;
    const mergedRef = mergeRefs(refFromProps, refFromContext);
    const propsWithRef = {
      ...implementationTypeProps,
      ref: mergedRef
    };
    ImplementationComponentType.displayName = `FlowComponentImpl(${componentName})`;
    let element = /* @__PURE__ */ jsx(ImplementationComponentType, { ...propsWithRef });
    if ("slot" in props && !!props.slot && typeof props.slot === "string") {
      element = /* @__PURE__ */ jsx(SlotContextProvider, { slot: props.slot, component: componentName, children: element });
    }
    if (wrapWith) {
      element = cloneElement(wrapWith, void 0, element);
    }
    if (tunnelId) {
      element = /* @__PURE__ */ jsx(TunnelEntry, { id: tunnelId, children: element });
    }
    return element;
  }
  Component.displayName = `FlowComponent(${componentName})`;
  return Component;
}

export { flowComponent };
//# sourceMappingURL=flowComponent.mjs.map
